<script setup lang="ts"></script>

<template>
	<div class="w-full min-h-screen bg-white flex items-center justify-center text-center">
		<div>
			<p class="text-grey-darker text-2xl md:text-3xl font-light mb-8 leading-normal">
				Sorry, u kunt zich momenteel niet inloggen.
				<br />
				Probeer het later nog eens.
			</p>

			<p class="text-grey-darker text-2xl md:text-3xl font-light mb-8 leading-normal">
				Désolé, vous ne pouvez pas vous connecter pour le moment.
				<br />
				Veuillez réessayer plus tard.
			</p>

			<p class="text-grey-darker text-2xl md:text-3xl font-light mb-8 leading-normal">
				Sorry, you cannot log in at the moment.
				<br />
				Please try again later.
			</p>
		</div>
	</div>
</template>

<style scoped></style>
